import React from 'react';
import { ZoneCalculator } from '/react4xp/parts/zone-calculator/ZoneCalculator'; 

export default (props) => <ZoneCalculator {...props} />
